import fontUrl from '../assets/fonts/MPLUS1p-Regular.ttf?url';

const FONT_FILE = 'MPLUS1p-Regular.ttf';
const FONT_FAMILY = 'mplus1p';

let cachedFontBase64: string | null = null;
let loadPromise: Promise<string> | null = null;

const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    for (let j = 0; j < chunk.length; j++) {
      binary += String.fromCharCode(chunk[j]);
    }
  }
  return btoa(binary);
};

const isValidTtf = (buffer: ArrayBuffer): boolean => {
  if (buffer.byteLength < 100_000) {
    return false;
  }
  const view = new DataView(buffer);
  const signature = view.getUint32(0);
  // TrueType: 0x00010000, OpenType with CFF: 'OTTO'
  return signature === 0x00010000 || signature === 0x4f54544f;
};

export const loadJapaneseFontBase64 = async (): Promise<string> => {
  if (cachedFontBase64) {
    return cachedFontBase64;
  }
  if (!loadPromise) {
    loadPromise = fetch(fontUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`フォントの読み込みに失敗しました (${response.status})`);
        }
        const contentType = response.headers.get('content-type') ?? '';
        if (contentType.includes('text/html')) {
          throw new Error('フォントファイルが見つかりません（HTMLが返されました）');
        }
        return response.arrayBuffer();
      })
      .then((buffer) => {
        if (!isValidTtf(buffer)) {
          throw new Error('フォントファイルが不正です');
        }
        cachedFontBase64 = arrayBufferToBase64(buffer);
        return cachedFontBase64;
      })
      .catch((error) => {
        loadPromise = null;
        throw error;
      });
  }
  return loadPromise;
};

export const registerJapaneseFont = (
  doc: import('jspdf').jsPDF,
  fontBase64: string
): boolean => {
  doc.addFileToVFS(FONT_FILE, fontBase64);
  doc.addFont(FONT_FILE, FONT_FAMILY, 'normal');

  const fontList = doc.getFontList();
  return Boolean(fontList && FONT_FAMILY in fontList);
};

export const JAPANESE_FONT_FAMILY = FONT_FAMILY;
